import React from 'react';

import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';
import ToastContainer from './components/ui/ToastContainer';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <AppContent />
          <ToastContainer />
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
};

const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--surface)' }}>
        <div className="text-center">
          <div
            className="animate-spin rounded-full h-6 w-6 border-2 border-t-transparent mx-auto mb-3"
            style={{ borderColor: 'var(--border)', borderTopColor: 'var(--text-muted)' }}
          />
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <Dashboard />;
};

export default App;
